import classes from "./UnauthorizedView.module.css";

export const UnauthorizedView = () => {
  return (
    <div className={classes.UnauthorizedView}>
      <h2>Brak dostępu.</h2>
    </div>
  );
};
